export default {
    updateNamePage(context, namePage) {
        context.commit('UPDATE_NAME_PAGE', namePage)
    },
}